export default __webpack_public_path__ + "static/media/desk.a98161cb.ogg";